import {
  GET_METRICS,
  GET_METRICS_ERROR,
  GET_METRICS_SUCCESS,
  SELECT_METRIC,
  UPDATE_METRIC_NAME,
  UPDATE_METRIC_DESC,
  SAVE_METRIC_TITLE_DESC,
  SAVE_METRIC_TITLE_DESC_SUCCESS,
  SAVE_METRIC_TITLE_DESC_ERROR,
  GET_SELECTED_METRIC_DATA_SUCCESS,
  GET_SELECTED_METRIC_DATA_ERROR,
  UPDATE_METRIC_VISIBILITY_SUCCESS,
  UPDATE_OTHER_REPORTS_URL,
  SAVE_OTHER_REPORTS_URL,
  SAVE_OTHER_REPORTS_URL_SUCCESS,
  SAVE_OTHER_REPORTS_URL_ERROR,
  UPDATE_METRIC_VISIBILITY_ERROR,
  UPDATE_METRIC_VISIBILITY,
  RESET_SAVED_SUCCESS_MESSAGE,
} from "./actions";
import { metricsState } from "./state";
import * as _ from "lodash";

export const initialMetricsState = {
  allMetrics: null,
  selectedMetric: null,
  updatedSelectedMetric: null,
  selectedMetricData: null,
  changesToSave: null,
  savedSuccessfully: null,
  pending: null,
  errors: null,
};

//remember to avoid mutation within reducers
export function metrics(state = initialMetricsState, Actions): metricsState {
  switch (Actions.type) {
    case GET_METRICS:
      return Object.assign({}, state, {
        pending: true,
        errors: null,
        savedSuccessfully: null,
      });
    case GET_METRICS_SUCCESS:
      return Object.assign({}, state, {
        allMetrics: Actions.payload,
        pending: false,
      });
    case GET_METRICS_ERROR:
      return Object.assign({}, state, {
        pending: false,
        selectedMetric: null,
        errors: {
          titleAndDesc:
            "There was an error when requesting your metrics! Please try again later.",
        },
      });
    case SELECT_METRIC:
      let metric = _.filter(state.allMetrics, {
        kpi_id: parseInt(Actions.payload),
      })[0];
      return Object.assign({}, state, {
        selectedMetric: metric,
        updatedSelectedMetric: metric,
        changesToSave: null,
        savedSuccessfully: null,
        selectedMetricData: null,
      });
    case UPDATE_METRIC_NAME:
      let updatedMetricAfterNameChange;
      Actions.payload === null
        ? (updatedMetricAfterNameChange = {
            ...state.updatedSelectedMetric,
            long_name: state.selectedMetric["long_name"],
          })
        : (updatedMetricAfterNameChange = {
            ...state.updatedSelectedMetric,
            long_name: Actions.payload,
          });
      let hasChangesAfterNameChange =
        state.selectedMetric["long_name"] !=
          updatedMetricAfterNameChange["long_name"] ||
        state.selectedMetric["definition"] !=
          state.updatedSelectedMetric["definition"];
      return Object.assign({}, state, {
        updatedSelectedMetric: updatedMetricAfterNameChange,
        changesToSave: {
          ...state.changesToSave,
          titleAndDesc: hasChangesAfterNameChange,
        },
        savedSuccessfully: { ...state.savedSuccessfully, titleAndDesc: null },
      });
    case UPDATE_METRIC_DESC:
      let updatedMetricAfterDescChange;
      Actions.payload === null
        ? (updatedMetricAfterDescChange = {
            ...state.updatedSelectedMetric,
            definition: state.selectedMetric["definition"],
          })
        : (updatedMetricAfterDescChange = {
            ...state.updatedSelectedMetric,
            definition: Actions.payload,
          });
      let hasChangesAfterDescChange =
        state.selectedMetric["definition"] !=
          updatedMetricAfterDescChange["definition"] ||
        state.selectedMetric["long_name"] !=
          state.updatedSelectedMetric["long_name"];
      return Object.assign({}, state, {
        updatedSelectedMetric: updatedMetricAfterDescChange,
        changesToSave: {
          ...state.changesToSave,
          titleAndDesc: hasChangesAfterDescChange,
        },
        savedSuccessfully: { ...state.savedSuccessfully, titleAndDesc: null },
      });
    case SAVE_METRIC_TITLE_DESC:
      return Object.assign({}, state, {
        pending: true,
        errors: { ...state.errors, titleAndDesc: null },
      });
    case SAVE_METRIC_TITLE_DESC_SUCCESS:
      return Object.assign({}, state, {
        selectedMetric: {
          ...state.selectedMetric,
          long_name: state.updatedSelectedMetric.long_name,
          definition: state.updatedSelectedMetric.definition,
        },
        changesToSave: { ...state.changesToSave, titleAndDesc: null },
        savedSuccessfully: { ...state.savedSuccessfully, titleAndDesc: true },
        pending: false,
        allMetrics: updateMetricInMetrics(state, state.updatedSelectedMetric, [
          "long_name",
          "definition",
        ]),
      });
    case SAVE_METRIC_TITLE_DESC_ERROR:
      return Object.assign({}, state, {
        pending: false,
        savedSuccessfully: { ...state.savedSuccessfully, titleAndDesc: false },
        errors: {
          ...state.errors,
          titleAndDesc:
            "There was an error in saving your metric updates! Please try again later.",
        },
      });
    case GET_SELECTED_METRIC_DATA_SUCCESS:
      return Object.assign({}, state, {
        selectedMetricData: Actions.payload,
        pending: false,
      });
    case GET_SELECTED_METRIC_DATA_ERROR:
      return Object.assign({}, state, {
        pending: false,
        errors: {
          ...state.errors,
          titleAndDesc:
            "There was an error when requesting this metric's data. Please select another metric or try again later.",
        },
      });
    case UPDATE_METRIC_VISIBILITY:
      return {
        ...state,
        pending: true,
        errors: { ...state.errors, metricVisibility: null },
      };
    case UPDATE_METRIC_VISIBILITY_SUCCESS:
      return {
        ...state,
        allMetrics: Actions.payload,
        pending: false,
        savedSuccessfully: {
          ...state.savedSuccessfully,
          metricVisibility: true,
        },
      };
    case UPDATE_METRIC_VISIBILITY_ERROR:
      return {
        ...state,
        pending: false,
        errors: {
          ...state.errors,
          metricVisibility:
            "There was an error when saving this metric visibility change. Please try again.",
        },
      };
    case RESET_SAVED_SUCCESS_MESSAGE:
      return {
        ...state,
        savedSuccessfully: {
          ...state.savedSuccessfully,
          [Actions.payload]: null,
        },
      };
    case UPDATE_OTHER_REPORTS_URL:
      const URL_REGEXP = new RegExp(
        "^((ft|htt)ps?:\\/\\/)?" + // protocol
          "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" + // domain name and extension
          "((\\d{1,3}\\.){3}\\d{1,3}))" + // OR ip (v4) address
          "(\\:\\d+)?" + // port
          "(\\/[-a-z\\d%@_.~+&:#]*)*" + // path
          "(\\?[;&a-z\\d%@_.,~+&:=-]*)?" + // query string
          "(\\#[-a-z\\d_]*)?$",
        "i"
      ); // fragment locator
      if (
        Actions.payload == "" &&
        state.selectedMetric["otherReportsUrl"] == null
      ) {
        // case where there is no url saved initially and the user has cleared what they have typed before
        return {
          ...state,
          errors: { ...state.errors, otherReportsUrl: null },
          changesToSave: { ...state.changesToSave, otherReportsUrl: false },
          savedSuccessfully: {
            ...state.savedSuccessfully,
            otherReportsUrl: null,
          },
        };
      } else {
        let validUrl = URL_REGEXP.test(Actions.payload);
        if (!validUrl && Actions.payload != "") {
          return {
            ...state,
            errors: {
              ...state.errors,
              otherReportsUrl: "Please enter a valid url",
            },
          };
        } else {
          let updatedSelectedMetricAfterLinkChange = {
            ...state.updatedSelectedMetric,
            otherReportsUrl: Actions.payload,
          };
          let ddlChangesToSave =
            state.selectedMetric["otherReportsUrl"] != Actions.payload;
          return {
            ...state,
            errors: { ...state.errors, otherReportsUrl: null },
            updatedSelectedMetric: updatedSelectedMetricAfterLinkChange,
            changesToSave: {
              ...state.changesToSave,
              otherReportsUrl: ddlChangesToSave,
            },
            savedSuccessfully: {
              ...state.savedSuccessfully,
              otherReportsUrl: null,
            },
          };
        }
      }
    case SAVE_OTHER_REPORTS_URL:
      return Object.assign({}, state, {
        pending: true,
        errors: { ...state.errors, otherReportsUrl: null },
      });
    case SAVE_OTHER_REPORTS_URL_SUCCESS:
      return {
        ...state,
        selectedMetric: {
          ...state.selectedMetric,
          otherReportsUrl: state.updatedSelectedMetric.otherReportsUrl,
        },
        pending: false,
        savedSuccessfully: {
          ...state.savedSuccessfully,
          otherReportsUrl: true,
        },
        changesToSave: { ...state.changesToSave, otherReportsUrl: false },
        allMetrics: updateMetricInMetrics(state, state.updatedSelectedMetric, [
          "otherReportsUrl",
        ]),
      };
    case SAVE_OTHER_REPORTS_URL_ERROR:
      return Object.assign({}, state, {
        savedSuccessfully: {
          ...state.savedSuccessfully,
          otherReportsUrl: false,
        },
        pending: false,
        errors: {
          ...state.errors,
          otherReportsUrl:
            "There was an error in saving your metric updates! Please try again later.",
        },
      });
    default:
      return state;
  }
}

function updateMetricInMetrics(state, updatedMetric, fields) {
  let updatedMetrics = _.cloneDeep(state.allMetrics);
  _.each(fields, (field) => {
    _.find(updatedMetrics, { kpi_id: updatedMetric.kpi_id })[field] =
      updatedMetric[field];
  });
  return updatedMetrics;
}
